module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright",
    attrs: {
      "id": "cop"
    }
  }, [_c('p', {
    staticClass: "crt1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE ENTITY")]), _vm._v(". Copyright © 2004 by Eric Frattini. English translation copyright © 2008 by Dick Cluster. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('a', {
    staticClass: "pubhlink",
    attrs: {
      "href": "http://www.stmartins.com",
      "target": "_blank"
    }
  }, [_vm._v("www.stmartins.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Frattini, Eric."), _c('br'), _vm._v("      The entity: five centuries of secret Vatican espionage / Eric Alonso Frattini; Translated by Dick"), _c('br'), _vm._v("Cluster."), _c('br'), _vm._v("          p. cm."), _c('br'), _vm._v("      ISBN-13: 978-0-312-37594-2"), _c('br'), _vm._v("      ISBN-10: 0-312-37594-8")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("   1. Espionage—Vatican City—History. 2. Intelligence service—Vatican City—History. I. Title."), _c('br'), _vm._v("      UB271.V38F73 2008"), _c('br'), _vm._v("      327.12456’34—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("2008025769")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("First published in Spain by Espasa Calpe under the title "), _c('em', [_vm._v("La Santa Alianza")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("First U.S. Edition: November 2008")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fbda5e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312375942_epub_cop_r1.vue
// module id = 63
// module chunks = 0